import { Outlet } from "react-router-dom";

const Orders = () => {
  return <Outlet />;
};

export default Orders;
